import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import { MouseIcon } from '../../../assets/icons/MouseIcon';
import { V2Cta, V2Frame } from '../sections/v2';
import { LandingVariantProps } from './types';

/**
 * LP2 new-UX (`phone-and-link-v1`) — phone and online CTAs side by side
 * (stacked on mobile). Phone button uses the brand primary tokens; the
 * online button uses the secondary tokens.
 */
export const PhoneAndLinkV1: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => {
  const phoneHref = copy.ctaPhoneLink ?? data.ctaPhoneLink;
  return (
    <V2Frame
      data={data}
      copy={copy}
      cta={
        <>
          <V2Cta heading={`${copy.registration} **`} subCopy={copy.phoneSubCopy}>
            <ButtonLink
              leftIcon={Phone()}
              href={phoneHref}
              variant="primary"
              id="phone-cta"
              onClick={() => onCtaClick('phone', phoneHref)}
            >
              {copy.ctaPhoneText}
            </ButtonLink>
          </V2Cta>
          <V2Cta
            heading={
              copy.onlineCopyDesktop ? (
                <>
                  <span className="v2-text-mobile">{copy.onlineCopy}</span>
                  <span className="v2-text-desktop">{copy.onlineCopyDesktop}</span>
                </>
              ) : (
                copy.onlineCopy
              )
            }
          >
            <ButtonLink
              leftIcon={<MouseIcon />}
              href={data.ctaOnlineLink}
              variant="secondary"
              id="online-link-cta"
              onClick={() => onCtaClick('online', data.ctaOnlineLink)}
            >
              {copy.ctaOnlineText}
            </ButtonLink>
          </V2Cta>
        </>
      }
    />
  );
};
